<router-outlet>
  <app-spinner></app-spinner>
  <ng-snotify ngClass="material"></ng-snotify>
</router-outlet>
